import React, { useContext, useEffect, useState } from 'react'
import { MatchupContext } from '../../../../Context'
import { SectionHeading } from '../../../../Components/Headers'
import { TeamStanding } from '../../../../Api'
import { CURRENT_YEAR } from '../../../../Config/League/league.config'
import { SEASON_SEGMENT_NAMES } from '../../../../Utils'
import { Box } from '../../../../Components/Layout'
import { StandingsSection } from '../../../../Components/Standings/StandingsSection'
import { Con } from '../../../../Components/Layout/Containers/ConStyles'

export const MatchupStandings: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { eventInfo, isLoading, standings, getStandings } =
    useContext(MatchupContext)!
  const [teamStandings, setTeamStandings] = useState<TeamStanding[]>([])
  const standingsYear = eventInfo?.week === '1' ? eventInfo.year - 1 : eventInfo?.year

  useEffect(() => {
    if (isLoading || !eventInfo) return
    if (teamStandings.length > 0) return
    retrieveStandings()
  }, [standings, isLoading, eventInfo])

  const retrieveStandings = async () => {
    if (!eventInfo) return
    const standingsRes = await getStandings(
      standingsYear ?? CURRENT_YEAR,
      eventInfo.seasonSegment === SEASON_SEGMENT_NAMES.champseries
    )
    setTeamStandings(standingsRes)
  }

  return (
    <>
      {teamStandings.length > 0 && (
        <Box boxColor="grey">
          <SectionHeading headingColor="light">
            <strong>Standings</strong>
          </SectionHeading>
          <Con direction="column" noPadding justify="center">
            <StandingsSection
              items={teamStandings}
              seasonSelect={{
                year: standingsYear || CURRENT_YEAR,
                seasonType: eventInfo?.seasonSegment || SEASON_SEGMENT_NAMES.regular,
              }}
              section={'matchup_page'}
              theme="dark"
              full
            />
          </Con>
          <Con vertMargins={8}></Con>
        </Box>
      )}
    </>
  )
}